import copy from 'copy-to-clipboard';
import React, { FC, ReactElement, useEffect, useState } from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import i18next from 'i18next';
import { CheckLg, Clipboard } from 'react-bootstrap-icons';

type CopyValueBoxProps = {
  value: string;
  valueCopy?: string | null;
  compact?: boolean;
}

const COPY_SUCCESS_DURATION: number = 2000;

const CopyValueBox: FC<CopyValueBoxProps> = ({ value, valueCopy = null, compact = false }: CopyValueBoxProps): ReactElement => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return;
    }
    
    const timeout: ReturnType<typeof setTimeout> = setTimeout(() => {
      setCopied(false)
    }, COPY_SUCCESS_DURATION)
    
    return (): void => {
      clearTimeout(timeout)
    }
  }, [copied]);
  
  
  
  const onCopyClickHandler = (): void => {
    copy(valueCopy ?? value);
    setCopied(true);
  };
  
  return (
    <div className="d-inline-flex flex-column align-items-start">
      <ButtonGroup className="d-inline-flex align-items-stretch">
        <Form.Control
          disabled
          value={value}
          className="rounded-end-0"
        />
        
        <Button
          variant={copied ? 'success' : 'primary'}
          className="d-inline-flex align-items-center justify-content-center text-nowrap rounded-start-0"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            onCopyClickHandler();
          }}
        >
          {copied ? <CheckLg /> : <Clipboard />}
          {!compact && (
            <span className="ms-2">
              {copied ? i18next.t('generic.copied') : i18next.t('generic.copy')}
            </span>
          )}
        </Button>
      </ButtonGroup>

      {copied && (
        <div 
          className="position-absolute top-100 start-50 translate-middle-x mt-2 px-2 py-1 small bg-success text-white rounded shadow-sm text-center text-nowrap"
          style={{ zIndex: 10 }}
        >
          {i18next.t('generic.copiedInfo')}
        </div>
      )}
    </div>
  )
};

export default CopyValueBox;
